export const MEDIA_QUERY_WIDTH_DESKTOP = "min-width: 1600px";
export const MEDIA_QUERY_WIDTH_LAPTOP_WIDTH = "max-width: 1200px";
export const MEDIA_QUERY_WIDTH_MOBILE_WIDTH = "max-width: 900px";
export const MEDIA_QUERY_HEIGHT_THIN = "max-height: 1100px";
